// extracted by mini-css-extract-plugin
module.exports = {"Calendar":"Calendar_Calendar__3ipAS","OverviewOptions":"Calendar_OverviewOptions__PE5Qd","textFilter":"Calendar_textFilter__3icEj","EventList":"Calendar_EventList__2K9st"};